import React, { Component } from 'react';
import { func } from 'prop-types';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';

import {
  Button,
  Modal,
  SimpleDialog,
  Dialog,
} from '@snapask/common-components';
import Gray from '@snapask/common-components/styles/buttonTheme/gray.scss';

import { actions } from '@blueberry/redux/post';

import { LOGIN, SIGNUP } from '@blueberry/constants/landingPage';

import config from '@blueberry/config';
const { SNAPASK_SITE_ENDPOINT } = config;

import styles from './LoginDialog.scss';
import whiteDialogTheme from './white.scss';

import SignupImage from './images/img-dialog-signup.svg';

class LoginDialog extends Component {
  static propTypes = {
    hideLoginDialog: func.isRequired,
    t: func.isRequired,
  };

  closeModal = () => {
    const { hideLoginDialog } = this.props;

    hideLoginDialog();
  };

  renderContentBlock() {
    const { t } = this.props;

    return (
      <SimpleDialog
        title={t('signup:signup.title')}
        description={t('signup:signup.description')}
        bgImage={SignupImage}
        theme={whiteDialogTheme}
      >
        <a href={`${SNAPASK_SITE_ENDPOINT}/${LOGIN}`}>
          <Button theme={Gray} text={t('navbar:navbar.login')} ghost />
        </a>
        <a href={`${SNAPASK_SITE_ENDPOINT}/${SIGNUP}`}>
          <Button text={t('login:login.signup')} />
        </a>
      </SimpleDialog>
    );
  }

  renderDesktopModal() {
    return (
      <div className={styles.desktop}>
        <Modal onClose={this.closeModal}>{this.renderContentBlock()}</Modal>
      </div>
    );
  }

  renderMobileModal() {
    return (
      <div className={styles.mobile}>
        <Dialog onCrossClick={this.closeModal} theme={styles}>
          {this.renderContentBlock()}
        </Dialog>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderDesktopModal()}
        {this.renderMobileModal()}
      </div>
    );
  }
}

export default compose(
  translate(['content', 'navbar', 'signup', 'login']),
  connect(null, {
    hideLoginDialog: actions.hideLoginDialog,
  })
)(LoginDialog);



// WEBPACK FOOTER //
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/SocialMedia/components/LikeBlock/components/LoginDialog/LoginDialog.jsx